import { PlayerError } from '@dtvgo/player-common-utils';

function isLicenseError(error) {
  return error.code === PlayerError.Code.LICENSE_REQUEST_FAILED;
}
function removePeriodsWithoutAudio(dashManifestXML) {
  for (const period of dashManifestXML.querySelectorAll("Period")) {
    if (period.querySelectorAll('AdaptationSet[mimeType="audio/mp4"],AdaptationSet[contentType="audio"]').length === 0) {
      period.remove();
    }
  }
  return dashManifestXML;
}
function removeAds(url) {
  const parsedUrl = new URL(url);
  if (parsedUrl.searchParams.has("da")) {
    parsedUrl.searchParams.set("da", "0");
  }
  return parsedUrl.toString();
}
function getSourceWithoutAds(source) {
  const newUrls = {
    dash: source.dash ? removeAds(source.dash) : source.dash,
    hls: source.hls ? removeAds(source.hls) : source.hls
  };
  if (newUrls.dash === source.dash && newUrls.hls === source.hls)
    return source;
  return {
    ...source,
    ...newUrls
  };
}

export { getSourceWithoutAds, isLicenseError, removeAds, removePeriodsWithoutAudio };
//# sourceMappingURL=utils.js.map
